import { useState, useEffect } from "react";
import "../Css/Header.css";
import logo from "../assets/iitchinmaylogo.png";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
 
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [courseOpen, setCourseOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
 
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
 
  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
    setCourseOpen(false);
  }, [location]);
 
  const isActive = (path) => location.pathname === path;
 
  return (
    <header className={`emerald-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        {/* Logo Section */}
        <Link to="/" className="logo-area">
          <img src={logo} alt="IITian's Chinmay Academy" />
          <div className="logo-text">
            <h1>IITian's Chinmay <span>Academy</span></h1>
          </div>
        </Link>
 
        {/* Mobile Toggle Button */}
        <button className="hamburger-btn" onClick={() => setMenuOpen(true)}>
          <FaBars />
        </button>
 
        {/* Navigation Menu */}
        <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <button className="close-btn" onClick={() => setMenuOpen(false)}>
            <FaTimes />
          </button>
 
          <div className="nav-links-wrapper">
            <Link to="/" className={isActive("/") ? "active" : ""}>Home</Link>
            {/* <Link to="/classes" className={isActive("/classes") ? "active" : ""}>Online Coaching</Link> */}
            <Link to="/about-us" className={isActive("/about-us") ? "active" : ""}>About Us</Link>
           
            <div className={`nav-dropdown ${courseOpen ? "is-open" : ""}`}>
              <div className="dropdown-trigger" onClick={() => setCourseOpen(!courseOpen)}>
                Courses <FaChevronDown className="chevron-icon" />
              </div>
              <div className="mega-menu">
                <Link to="/jee-coaching-in-vadodara">JEE Mains & Advanced</Link>
                <Link to="/neet-coaching-in-vadodara">NEET (Medical)</Link>
                <Link to="/foundation-classes-in-vadodara">Foundation Courses</Link>
              </div>
            </div>
 
            {/* <Link to="/classes" className={isActive("/classes") ? "active" : ""}>Classes</Link> */}
            <Link to="/gallery" className={isActive("/gallery") ? "active" : ""}>Gallery</Link>
            <Link to="/blog" className={isActive("/blog") ? "active" : ""}>Blog</Link>
            <Link to="/videos" className={isActive("/videos") ? "active" : ""}>Videos</Link>
            <Link to="/contact" className="contact-cta-btn">Contact Us</Link>
          </div>
        </nav>
 
        {/* Overlay for closing menu */}
        {menuOpen && <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>}
      </div>
    </header>
  );
};
 
export default Header;